// extracted by mini-css-extract-plugin
module.exports = {"team":"Footer_team__2gWf6"};